module.exports = __webpack_public_path__ + "static/img/bj.188c255.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/bj.png
// module id = hZAR
// module chunks = 1